/** @file The tile edge whose outward normal is an image angle (the `cutAngle` slot read back). */
import { wrapDegrees } from '@zilo/pose3d-std/math/wrapDegrees';
import type { TileEdge } from '@zilo/pose3d-render-core/cut/tileEdges';

const BY_QUARTER: readonly TileEdge[] = ['bottom', 'right', 'top', 'left'];

/** 0 bottom, 90 right, 180 top, 270 left; other angles go to the nearest quarter. */
export function edgeOfNormal(angleDeg: number): TileEdge {
  return BY_QUARTER[Math.round(wrapDegrees(angleDeg) / 90) % 4] ?? 'bottom';
}
